import React, {useEffect, useRef, useState} from 'react';
import API from "../utils/API";
import Error from "./Error";
import Forms from "./Forms";
import {useTranslation} from 'react-i18next';
import {API_ENDPOINTS} from "../apiConfig";

const ANSWER_TYPE_OPTIONS = [
    {value: 'status', label: 'Netestováno | Funkční | Nefunkční'},
    {value: 'number', label: 'Číselná odpověď'},
    {value: 'grade', label: 'A | B | C'}
];

const DiagnosticCatalogModal = ({close, onUpdate, item}) => {
    const [name, setName] = useState('');
    const [answerType, setAnswerType] = useState(ANSWER_TYPE_OPTIONS[0]);
    const [error, setError] = useState('');
    const {t} = useTranslation();
    const inputRef = useRef(null);

    useEffect(() => {
        setName(item ? item.name : '');
        setAnswerType(ANSWER_TYPE_OPTIONS.find((option) => option.value === item?.answerType) || ANSWER_TYPE_OPTIONS[0]);
    }, [item]);

    useEffect(() => {
        setTimeout(() => inputRef.current?.focus(), 0);
    }, []);

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setError();
        try {
            const payload = {
                name: String(name || '').trim(),
                answerType: answerType?.value || 'status'
            };
            if (item?._id) {
                await API.put(API_ENDPOINTS.diagnosticCatalog.edit(item._id), payload);
            } else {
                await API.post(API_ENDPOINTS.diagnosticCatalog.add, payload);
            }
            onUpdate?.();
            close?.();
        } catch (err) {
            setError(err);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4">
                <Forms.Text
                    required
                    ref={inputRef}
                    label="Název položky"
                    placeholder="Např. FaceID"
                    value={name}
                    onChange={setName}
                />
                <Forms.Select
                    required
                    label="Typ odpovědi"
                    value={answerType}
                    options={ANSWER_TYPE_OPTIONS}
                    onChange={(val) => setAnswerType(val || ANSWER_TYPE_OPTIONS[0])}
                />
            </div>
            {error && <Error error={error}/>}
            <Forms.Button onClick={handleSubmit} label={item ? t('update') : t('save')} className="mt-4"/>
        </form>
    );
};

export default DiagnosticCatalogModal;
